import { queryOptions } from "@tanstack/react-query";

import { api } from "./api";

/** The broker this deployment serves; the declarant on every export. One row, admin-edited. */
export interface CompanyProfile {
  id: string;
  name: string;
  crib_number: string;
  address: string;
  deferred_payment_reference: string;
  default_declaration_type: string | null;
  default_office_of_entry: string | null;
  default_office_of_destination: string | null;
  default_location_of_goods: string | null;
  default_port_of_unloading: string | null;
  default_country_of_destination: string | null;
  default_transport_mode: string | null;
  default_nature_of_transaction: string | null;
  default_inco_term: string | null;
  default_currency: string | null;
  updated_at: string;
}

export type CompanyProfilePatch = Partial<Omit<CompanyProfile, "id" | "updated_at">>;

export const companyQuery = queryOptions({
  queryKey: ["company"],
  queryFn: () => api<CompanyProfile>("/company/"),
  staleTime: 5 * 60 * 1000,
});

export const companyApi = {
  update: (patch: CompanyProfilePatch) =>
    api<CompanyProfile>("/company/", { method: "PATCH", body: patch }),
};
